module.exports = __webpack_public_path__ + "static/media/builder.778b293a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/commanders/builder.png
// module id = 2067
// module chunks = 0